module.exports = __webpack_public_path__ + "img/adv-landing-3cars.20c0c689.png";